module.exports = __webpack_public_path__ + "static/img/son1_active.a7eaa01d.png";